import Lottie from 'react-lottie'
import animationData from './AnimationData.json'

const SnippetDivider = () => {
    const lottieOptions = {
        loop: true,
        autoplay: true,
        isClickToPauseDisabled: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    return (
        <section className="snippet-divider">
            <div className="snippet-divider__container">
                <Lottie
                    options={lottieOptions}
                    height={310}
                    width={1440}
                ></Lottie>
            </div>
        </section>
    )
}

export default SnippetDivider